<template>
  <div class="material-picker">
    <div class="grouping">
      <van-button
        v-for="(item, index) in tabbar"
        :key="index"
        :name="index"
        :class="['terminal-btn', { selected: activeKey === index }]"
        icon="/static/images/etv-folder.png"
        @click="onChange(index)"
      >
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div class="full-name">
      <van-checkbox
        v-if="multiple"
        v-model="checkAll"
        label-position="left"
        :indeterminate="isIndeterminate"
      >
        <span class="full-name__folder">{{ groupingName }}</span>
      </van-checkbox>
      <span v-else class="full-name__folder full-name__folder--single">{{ groupingName }}</span>
    </div>
    <div ref="materialList" class="materiallist abcds">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('append_field.noMore')"
          @load="onLoad"
        >
          <div class="content">
            <div class="photo" :style="itemStyle">
              <input
                ref="fileInput"
                type="file"
                @change="handleFileChange"
                style="display: none;"
              />
              <img
                v-if="$auth.hasPerms('material:data:upload')"
                class="up_loading"
                src="/static/images/program/updata.png"
                style="width: 100%; height: 100%;"
                @click="handleClick"
              />
            </div>
            <div
              v-for="(item, index) in materialList"
              :key="item.mtId || item.mid || `${item.name}-${index}`"
              class="materia-item"
              :class="{ 'is-disabled': isItemDisabled(item) }"
              :style="itemStyle"
              @click="toggleItem(item, index)"
            >
              <div class="checkbox">
                <van-checkbox
                  v-model="item.checked"
                  :disabled="isItemDisabled(item)"
                />
              </div>
              <div class="preview">
                <img
                  v-if="showImagePreview(item)"
                  v-lazy="getPreviewUrl(item)"
                  style="width: 100%; height: 100%;"
                  @error="errImg"
                />
                <img
                  v-else
                  :src="getPreviewUrl(item)"
                  style="width: 100%; height: 100%;"
                  @error="errImg"
                />
              </div>
              <div v-if="showDocStatus(item)" class="audit">
                <span v-if="Number(item.convertState) === 1" class="audit3">{{ $t('append_field.processing') }}</span>
                <span v-if="Number(item.convertState) === 2" class="audit3">{{ $t('append_field.failed') }}</span>
              </div>
              <span class="audit-name">{{ item.name }}</span>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="btns">
      <van-button color="#FF5700" size="small" @click="$emit('close')">{{ $t('append_field.cancel') }}</van-button>
      <span>{{ $t('append_field.selectedNumber') }} ({{ selectedItems.length }})</span>
      <van-button color="#006EFF" size="small" @click="submitSelection">{{ $t('append_field.confirm') }}</van-button>
    </div>

    <van-dialog v-model="showUploadProgress" :title="$t('append_field.Up')" :show-confirm-button="false">
      <div style="margin: 30px 0;">
        <div class="updata">
          <van-cell :title="$t('append_field.fileName')">
            <div class="updata-item">{{ fileName }}</div>
          </van-cell>
          <van-cell :title="$t('append_field.fileSize')">
            <div class="updata-item">{{ fileSize }}M</div>
          </van-cell>
          <van-cell :title="$t('append_field.uploadProgress')" />
          <van-cell>
            <div class="updata-item-right">
              <van-progress :percentage="complete" pivot-color="#006EFF" stroke-width="4" style="width: 100%;" />
            </div>
          </van-cell>
          <div class="updata-item">
            <div style="float: right; margin: 10px 16px 0 0;">
              <van-button color="#FF5700" size="small" @click="cancelUpload">{{ $t('append_field.cancelAllUploads') }}</van-button>
            </div>
          </div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="showUploadFileDialog" :title="$t('append_field.getUploadendTim')">
      <div class="dialog-content">
        <span>{{ uploadFileText }}</span>
        <span>{{ $t('append_field.getUploadstartTime_tip') }}</span>
      </div>
    </van-dialog>

    <van-overlay :show="showLoading">
      <div class="loading-mask">
        <van-loading size="40px" vertical>{{ loadingText }}...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant'
import qs from 'qs'
import axios from 'axios'
import uploadService from '@/utils/upload.service'
import $auth from '@/utils/auth'
import { calculateFileMd5, checkFileSize, getFileSuffix } from '@/utils'
import { classifyFileTypes, fileTypeList } from '@/utils/handleUpload'

const DOC_WORD_EXT = ['.doc', '.docx']
const DOC_PDF_EXT = ['.pdf']
const DOC_PPT_EXT = ['.ppt', '.pptx']
const DOC_EXCEL_EXT = ['.xls', '.xlsx']


function parseDateTime(dateTimeStr) {
  return new Date(dateTimeStr)
}

export default {
  name: 'MaterialPicker',
  props: {
    type: {
      type: String,
      required: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      width: 0,
      tabbar: [],
      groupingName: '',
      activeKey: 0,
      materialList: [],
      selectedItems: [],
      id: 1,
      folderIndex: 0,
      totalNum: 0,
      pageNum: 1,
      pageSize: 45,
      loading: false,
      finished: false,
      refreshing: false,
      loadingText: this.$t('append_field.loadingb'),
      showLoading: false,
      showUploadProgress: false,
      complete: 0,
      source: null,
      fileName: '',
      fileSize: 0,
      allowUpload: false,
      showUploadFileDialog: false,
      uploadFileText: '',
      uploadType: '',
      uploadCancelled: false,
      currentFileMd5: '',
    }
  },
  computed: {
    $auth() {
      return $auth
    },
    materialType() {
      const map = {
        image: 'img',
        background: 'img',
        video: 'video',
        audio: 'audio',
        doc: 'doc',
        mixture: 'mixture',
      }
      return map[this.type] || 'img'
    },
    itemStyle() {
      return {
        height: `${this.width}px`,
        width: `${this.width}px`,
      }
    },
    checkAll: {
      get() {
        const list = this.selectableItems
        if (!list.length) return false
        return list.every(item => item.checked)
      },
      set(checked) {
        this.setAllChecked(checked)
      },
    },
    isIndeterminate() {
      const list = this.selectableItems
      if (!list.length) return false
      const checkedCount = list.filter(item => item.checked).length
      return checkedCount > 0 && checkedCount < list.length
    },
    selectableItems() {
      return this.materialList.filter(item => !this.isItemDisabled(item))
    },
    selectToastKey() {
      return this.type === 'video' || this.type === 'audio' || this.type === 'mixture'
        ? 'append_field.selectVideo'
        : 'append_field.selectImage'
    },
  },
  mounted() {
    this.$nextTick(() => {
      const listEl = this.$refs.materialList
      if (listEl) {
        this.width = listEl.clientWidth / 4 - 2
      }
    })
    this.getFolder(0)
  },
  methods: {
    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'
    },
    truncatedName(fullName) {
      const namePart = fullName.split(' (')[0]
      const infoPart = fullName.includes('(') ? fullName.slice(fullName.indexOf('(')) : ''
      return namePart.length <= 4 ? fullName : `${namePart.substring(0, 4)}...${infoPart}`
    },
    showImagePreview() {
      return this.type !== 'audio' && this.type !== 'doc'
    },
    getPreviewUrl(item) {
      if (this.type === 'audio') {
        return '/static/images/program/msic.png'
      }
      if (this.type === 'doc') {
        return this.getDocIcon(item)
      }
      if (this.type === 'video') {
        return this.normalizeUrl(item.videoViewUrl || item.screenshotUrl)
      }
      if (this.type === 'mixture') {
        return this.normalizeUrl(
          item.type === 'video'
            ? (item.videoViewUrl || item.screenshotUrl)
            : (item.screenshotUrl || item.url)
        )
      }
      return this.normalizeUrl(item.screenShotUrl || item.screenshotUrl || item.url)
    },
    getDocIcon(item) {
      const suffix = `${String(item.suffix || getFileSuffix(item.name || '')).toLowerCase()}`

      if (DOC_PDF_EXT.includes(suffix)) return '/static/images/program/pdf.png'
      if (DOC_EXCEL_EXT.includes(suffix)) return '/static/images/program/xlsx.png'
      if (DOC_PPT_EXT.includes(suffix)) return '/static/images/program/ppt.png'

      if (DOC_WORD_EXT.includes(suffix)) return '/static/images/program/word.png'
      return '/static/images/icon_loader_failed_braseas.png'
    },
    normalizeUrl(url) {
      if (!url) return '/static/images/icon_loader_failed_braseas.png'
      return url.startsWith('http') ? url : this.upFileUrl + url
    },
    showDocStatus(item) {
      return this.type === 'doc' && this.isItemDisabled(item)
    },
    isItemDisabled(item) {
      if (this.type !== 'doc') return false
      const state = Number(item && item.convertState)
      return state === 1 || state === 2
    },
    syncSelectedItems() {
      this.selectedItems = this.materialList.filter(item => item.checked)
    },
    setAllChecked(checked) {
      if (!this.multiple) return
      this.materialList.forEach((item, index) => {
        if (this.isItemDisabled(item)) return
        item.checked = checked
        this.$set(this.materialList, index, item)
      })
      this.syncSelectedItems()
    },
    toggleItem(item, index) {
      if (this.isItemDisabled(item)) return
      if (this.multiple) {
        item.checked = !item.checked
      } else {
        const nextChecked = !item.checked
        this.materialList.forEach((row, rowIndex) => {
          row.checked = false
          this.$set(this.materialList, rowIndex, row)
        })
        item.checked = nextChecked
      }
      this.$set(this.materialList, index, item)
      this.syncSelectedItems()
    },
    submitSelection() {
      if (!this.selectedItems.length) {
        Toast(this.$t(this.selectToastKey))
        return
      }
      this.$emit('select', this.multiple ? this.selectedItems : this.selectedItems[0])
    },
    async getFolder(index) {
      this.loadingText = this.$t('append_field.loadingb')
      const res = await this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
        mtType: this.materialType,
        type: 'select',
        id: '',
        filterType: 1,
      }))
      if (res.data.code !== 0) return
      localStorage.setItem('lastSize', res.data.data.lastSize)
      this.tabbar = res.data.data.children || []
      if (!this.tabbar.length) return
      const current = this.tabbar[index] || this.tabbar[0]
      this.groupingName = current.name
      this.id = current.mfId
    },
    onChange(index) {
      if (this.activeKey !== index) {
        this.activeKey = index
      }
      this.folderIndex = index
      this.materialList = []
      this.selectedItems = []
      this.finished = false
      this.pageNum = 1
      const current = this.tabbar[index]
      if (current) {
        this.groupingName = current.name
        this.id = current.mfId
      }
      this.onLoad()
    },
    onLoad() {
      if (this.materialList.length >= this.totalNum && this.pageNum !== 1) {
        this.finished = true
        this.loading = false
        return
      }
      this.loading = true
      this.getMaterial(this.id, this.pageNum)
    },
    onRefresh() {
      this.finished = false
      this.pageNum = 1
      this.materialList = []
      this.selectedItems = []
      this.onLoad()
    },
    async getMaterial(id, pageNum) {
      const res = await this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
        id,
        type: this.materialType,
        pageNum,
        pageSize: this.pageSize,
        filterType: 1,
      })).catch(() => null)
      if (!res || res.data.code !== 0) {
        this.loading = false
        this.refreshing = false
        return
      }
      const newItems = (res.data.data.materialList || []).map(item => ({ ...item, checked: false }))
      this.totalNum = res.data.data.totalNum
      this.materialList = [...this.materialList, ...newItems]
      this.loading = false
      this.refreshing = false
      this.syncSelectedItems()
      if (this.materialList.length >= this.totalNum) {
        this.finished = true
      } else {
        this.pageNum += 1
      }
    },
    async handleClick() {
      try {
        const isAllowed = await this.getUploadSet()
        if (!isAllowed) {
          this.allowUpload = false
          return
        }
        this.allowUpload = true
        setTimeout(() => {
          this.$refs.fileInput.click()
        }, 0)
      } catch (error) {
        Toast(this.$t('append_field.getUploadSet_tip'))
        this.allowUpload = false
      }
    },
    async getUploadSet() {
      const res = await this.$ajax.post('/etv/getUploadSet.json').catch(() => null)
      if (!res || res.data.code !== 0) {
        Toast(this.$t('append_field.getUploadSet_tip'))
        return false
      }
      this.uploadType = res.data.data.uploadType
      const currentTime = new Date()
      const startTime = parseDateTime(res.data.data.startTime)
      const endTime = parseDateTime(res.data.data.endTime)
      if (currentTime >= startTime && currentTime <= endTime) {
        this.showUploadFileDialog = true
        this.uploadFileText = `${startTime.toLocaleString()} - ${endTime.toLocaleString()}`
        return false
      }
      return true
    },
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      const lastSize = Number(localStorage.getItem('lastSize') || 0)
      const fileSizeInMB = file.size / 1024 / 1024
      if (this.uploadType !== 2) {
        const suffix = getFileSuffix(file.name)
        const ext = `.${suffix.toLowerCase()}`
        const fileCategory = classifyFileTypes(ext)
        if (fileCategory === 'doc') {
          const allowedDocTypes = ['.pdf', '.xls', '.xlsx']
          if (!allowedDocTypes.includes(ext)) {
            Toast(this.$t('append_field.unsupportedFormat'))
            event.target.value = ''
            return
          }
        }
      }
      if (!fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
        Toast(this.$t('append_field.unsupportedFormat'))
        event.target.value = ''
        return
      }
      if (lastSize < fileSizeInMB) {
        Toast(`${this.$t('append_field.last_size')} ${lastSize}MB`, 'fail')
        event.target.value = ''
        return
      }
      if (fileSizeInMB < 1 / 1024 && ['png', 'jpg', 'jpeg', 'gif'].includes(file.name.split('.').pop().toLowerCase())) {
        Toast(this.$t('append_field.file_less_38'))
        event.target.value = ''
        return
      }
      if (!checkFileSize(file)) {
        this.toastSizeExceeded(file)
        event.target.value = ''
        return
      }

      this.fileName = file.name
      this.fileSize = (file.size / 1024 / 1024).toFixed(2)
      this.complete = 0
      this.showUploadProgress = true
      this.uploadCancelled = false
      this.currentFileMd5 = ''

      const MD5_PROGRESS_WEIGHT = 20
      const UPLOAD_PROGRESS_WEIGHT = 70
      await calculateFileMd5(file, (md5Percent) => {
        const totalProgress = Math.floor((md5Percent / 100) * MD5_PROGRESS_WEIGHT)
        if (totalProgress) {
          this.complete = totalProgress
        }
      })
      if (this.uploadCancelled) {
        this.uploadCancelled = false
        this.showUploadProgress = false
        this.complete = 0
        return
      }

      this.currentFileMd5 = file.fileMd5 || ''
      const result = await uploadService.upload(file, 1, localStorage.getItem('token'), this.uploadType, {
        onProgress: (percent) => {
          this.complete = Math.floor(MD5_PROGRESS_WEIGHT + (percent / 100) * UPLOAD_PROGRESS_WEIGHT)
        },
      })
      if (!result) {
        this.handleUploadError()
        return
      }

      const fd = new FormData()
      fd.append('mfId', this.id)
      fd.append('fileId', result.result)

      const cancelToken = axios.CancelToken
      this.source = cancelToken.source()
      await this.$ajax({
        url: this.upFileUrl + 'etv/uploadMaterial.json',
        method: 'post',
        cancelToken: this.source.token,
        data: fd,
      }).then((res) => {
        this.complete = 100
        event.target.value = ''
        if (res.data.code === 0) {
          this.handleUploadSuccess()
        } else {
          this.handleUploadError()
        }
      }).catch(() => {
        this.handleUploadError()
      })
    },
    toastSizeExceeded(file) {
      const suffix = getFileSuffix(file.name)
      const type = `.${suffix.toLowerCase()}`
      const fileType = classifyFileTypes(type)
      const sizeLimits = {
        image: 20 * 1024 * 1024,
        video: 4 * 1024 * 1024 * 1024,
        audio: 20 * 1024 * 1024,
        doc: 100 * 1024 * 1024,
      }
      const sizeLimitText = fileType === 'video'
        ? '4GB'
        : `${sizeLimits[fileType] / (1024 * 1024)}MB`
      const fileTypeName = {
        image: this.$t('append_field.image'),
        video: this.$t('append_field.control_video'),
        audio: this.$t('append_field.audio'),
        doc: this.$t('append_field.document'),
      }[fileType]
      Toast(`${fileTypeName}${this.$t('append_field.file_size_exceed_skip')}${sizeLimitText}`)
    },
    handleUploadSuccess() {
      this.materialList = []
      this.pageNum = 1
      this.selectedItems = []
      this.showUploadProgress = false
      this.complete = 0
      this.showLoading = true
      this.getFolder(this.folderIndex)
      setTimeout(() => {
        this.showLoading = false
        this.onLoad()
      }, 2000)
    },
    handleUploadError() {
      this.showUploadProgress = false
      this.complete = 0
      this.currentFileMd5 = ''
    },
    async cancelUpload() {
      try {
        this.uploadCancelled = true
        if (this.currentFileMd5) {
          await uploadService.cancelUpload(this.currentFileMd5)
        } else {
          uploadService.cancelAll()
        }
        if (this.source) {
          this.source.cancel(this.$t('material.cancelUpload'))
        }
      } catch (error) {
        console.error('cancel upload failed:', error)
      }
      this.complete = 0
      this.showUploadProgress = false
      Toast(this.$t('append_field.cancelAllUploads'))
    },
  },
  destroyed() {
    this.materialList = []
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.material-picker {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;

  .dialog-content {
    margin: 45px 16px;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }

  .dialog-content span {
    margin-bottom: 8px;
    word-break: break-word;
  }

  .full-name {
    margin: 0 10px;
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    min-height: 30px;
    line-height: 30px;

    .van-checkbox {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .van-checkbox__label {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      min-width: 0;
      font-size: 14px;
      color: #333;
    }
  }

  .full-name__folder {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #333;
  }

  .full-name__folder--single {
    display: block;
  }

  .materiallist {
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 90px;
    bottom: 60px;
    overflow: auto;
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
  }

  .photo,
  .materia-item {
    box-sizing: border-box;
    padding: 2px;
  }

  .materia-item {
    position: relative;
  }

  .materia-item.is-disabled {
    opacity: 0.7;
  }

  .checkbox {
    position: absolute;
    top: 1px;
    right: 5px;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .preview {
    width: 100%;
    height: 80%;
  }

  .audit-name {
    display: inline-block;
    width: 100%;
    line-height: 22px;
    font-size: 15px;
    color: #131212;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .audit {
    position: absolute;
    top: 60px;
    left: 5px;
    right: 0;
    z-index: 1;
    white-space: nowrap;
    color: #ffffff;
  }

  .audit3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 100%;
    font-size: 13px;
    background: rgba(241, 55, 61, 0.79);
  }

  .grouping {
    display: flex;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    height: 60px;
    gap: 10px;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid $uni-border-bottom-color;
    overflow-x: auto;
    .van-button {
      width: 200px !important;
    }

    .van-button__text {
      display: block;
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  }

  .terminal-btn {
    flex: 1 1 auto;
    white-space: nowrap;
    background-color: white;
    color: black;
    border: 1px solid #ddd;
  }


  .selected {
    background-color: #006EFF;
    color: white;
  }

  .btns {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .updata-item {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .updata-item-right {
    height: 20px;
    display: flex;
    align-items: center;
    color: #8c8c8c;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .loading-mask {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
